import { ENGAGEMENT_TYPES } from "./constants";

export const createCommentElementId = comment =>
  `neeto-molecules-engagement-comment--${comment.id}`;

export const defaultMatchType = engagement => {
  if (engagement.commenter) return ENGAGEMENT_TYPES.COMMENT;
  else if (engagement.creator) return ENGAGEMENT_TYPES.ACTIVITY;

  return null;
};
